export default "__VITE_PUBLIC_ASSET__bc3aed8e__"